import instance from "./request";

// 获取游戏列表
export function getGameList(value: any) {
    return instance.post('/game/listByLabel', value);
}

//游戏跳转
export function gameLink(value: any) {
    return instance.post('/game/joinGame', value);
}

//提交建议
export function submitSuggest(value: any) {
    return instance.post('/game/message', value);
}

// 请求游戏场次
export function gameSceneList(value: any) {
    return instance.post('/game/gameSceneList', value);
}

// 检查是否处于游戏中
export function checkInGame(value: any) {
    return instance.post('/vegas/wallet/checkInGame', value);
}